export const COURSE_JOIN = 'COURSE_JOIN'
export const COURSE_LEAVE = 'COURSE_LEAVE'
export const COURSES_UPDATED = 'COURSES_UPDATED'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case COURSES_UPDATED:
      // Return new state object so courses get re-rendered
      return { ...state, coursesUpdated: true }
    default:
      return state
  }
}

export const joinCourse = courseId => {
  return {
    type: COURSE_JOIN,
    courseId: courseId,
  }
}

export const leaveCourse = courseId => {
  return {
    type: COURSE_LEAVE,
    courseId: courseId,
  }
}

export const coursesUpdated = () => {
  return {
    type: COURSES_UPDATED,
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/coursesReducer.js